import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ProfileProvider } from './contexts/ProfileContext';
import Login from './components/Login';
import Layout from './components/layout/Layout';
import AdminDashboard from './components/AdminDashboard';
import UserDashboard from './components/UserDashboard';
import UserProfile from './components/UserProfile';
import UserManagement from './components/UserManagement';
import AccessManagement from './components/AccessManagement';
import AccessRequests from './components/AccessRequests';
import AccessLogs from './components/AccessLogs';
import Schedule from './components/Schedule';
import Schedules from './components/Schedules';
import Notifications from './components/Notifications';
import Departments from './components/Departments';
import AuditLogs from './components/AuditLogs';
import RequestAccess from './components/RequestAccess';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  
  console.log('🔒 ProtectedRoute Debug:', {
    token: !!token,
    role,
    allowedRoles,
    currentPath: window.location.pathname
  });

  if (!token) {
    console.log('❌ No token found, redirecting to login');
    return <Navigate to="/login" />;
  }

  // Only redirect if user's role is explicitly not allowed
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    console.log('❌ Role not allowed, redirecting:', {
      userRole: role,
      allowedRoles,
      redirectTo: role === 'admin' ? '/' : '/dashboard'
    });
    return <Navigate to={role === 'admin' ? '/' : '/dashboard'} />;
  }

  console.log('✅ Access granted to:', window.location.pathname);
  return children;
};

function App() {
  console.log('🚀 App component rendered');
  
  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <ProfileProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
            
            <Route path="/" element={
              <ProtectedRoute allowedRoles={['admin', 'user']}>
                <Layout />
              </ProtectedRoute>
            }>
              {/* Admin Routes */}
              <Route index element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="users" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <UserManagement />
                </ProtectedRoute>
              } />
              <Route path="departments" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <Departments />
                </ProtectedRoute>
              } />
              <Route path="access-requests" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AccessRequests />
                </ProtectedRoute>
              } />
              <Route path="schedules" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <Schedules />
                </ProtectedRoute>
              } />
              <Route path="access-logs" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AccessLogs />
                </ProtectedRoute>
              } />
              <Route path="audit-logs" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AuditLogs />
                </ProtectedRoute>
              } />

              {/* Common Routes (accessible by both admin and normal users) */}
              <Route path="dashboard" element={
                <ProtectedRoute allowedRoles={['admin', 'user']}>
                  <UserDashboard />
                </ProtectedRoute>
              } />
              <Route path="profile" element={
                <ProtectedRoute allowedRoles={['admin', 'user']}>
                  <UserProfile />
                </ProtectedRoute>
              } />
              <Route path="notifications" element={
                <ProtectedRoute allowedRoles={['admin', 'user']}>
                  <Notifications />
                </ProtectedRoute>
              } />

              {/* User Routes */}
              <Route path="access" element={
                <ProtectedRoute allowedRoles={['user']}>
                  <AccessManagement />
                </ProtectedRoute>
              } />
              <Route path="request-access" element={
                <ProtectedRoute allowedRoles={['user']}>
                  <RequestAccess />
                </ProtectedRoute>
              } />
              <Route path="schedule" element={
                <ProtectedRoute allowedRoles={['user']}>
                  <Schedule />
                </ProtectedRoute>
              } />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ProfileProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
